module.exports = __webpack_public_path__ + "static/media/harvardLogo.0e6a32c7.png";